<div class="guide_footer">
    <a class="prev" *ngIf="prev$ | async as prev" [routerLink]="[prev.route]" (click)="clickOnTop()"><i class="fas fa-step-backward"></i>{{ 'ULTIMATEGUIDE.PREV' | translate }}</a>
    <a class="next" *ngIf="next$ | async as next" [routerLink]="[next.route]" (click)="clickOnTop()">{{ 'ULTIMATEGUIDE.NEXT' | translate }}<i class="fas fa-step-forward"></i></a>
</div>
